import React, { useState, useEffect, useRef } from 'react'

import {

    Button, Dialog, Grid, Icon, RadioGroup,
    Typography, FormLabel, FormHelperText, FormControl,
    FormGroup, FormControlLabel, Checkbox, Radio, Select
} from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '../../../../assets/img/icons/binIcon.png';
import RichTextEditor from 'react-rte';
import { InputBaseField, SelectField, TextareaField } from '../../../../components/InputField/InputField';
import { Label, DraggableComponent } from '../../../../components/UiElements/UiElements'
import { PostDataAPI } from '../../../../Services/APIService';
import { withSnackbar } from "../../../../components/Message/Alert";
import { lstStates, lstCountry, lstMonths, documentType, sheilaProgramPlans } from '../../../../../src/components/Common/Lookup';
import useStyles from "./styles";
import { validateEmail, validatePhoneNumber, allowedAttachmentsImages, handleNumberKeyPress, getFormatedDate, formatDate } from '../../../../../src/components/Common/Extensions';
import PreviewPhoto from '../../../../assets/img/common/Loren-Solorzano-identity.jpg';
import axios from 'axios';
import DialogLoader from '../../../../components/Loader/DialogLoader';
import CropDemo from './../cropImg/CropExample';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { HealthcareTabletProgram, HealthcareTabletProgramApplyFor } from '../../../../../src/components/Common/AppEnums';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { ActionDialog } from '../../../../components/ActionDialog/ActionDialog';

function EditRequest({ dialogOpenClose, handleClose, handleSuccessClose, record, isPreviewMode, isSendPickUpEmail, applicationType, ...props }) {
    const classes = useStyles();
    const commonAttachments = allowedAttachmentsImages();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({});
    const { showMessage } = props;
    const [identityImage, setIdentityImage] = useState({ file: null, fileToSend: null, fileName: null });
    const [pictureReceivingPhone, setPictureReceivingPhone] = useState({ file: null, fileToSend: null, fileName: null });

    const closeDialog = () => {
        setBeneficiariesList();
        setIsBeneficiaryChanged(true);
        handleClose();
    }
    const [beneficiariesList, setBeneficiariesList] = useState([]);
    const [matchingChildrenWithParent, setMatchingChildrenWithParent] = useState([]);

    const handleAddBeneficiaryItem = () => {
        var listCount = beneficiariesList.filter(t => !t.isDeleted).length;
        if (listCount == 4) {
            showMessage("Error", "A maximum of 4 childs can be added", "error", 3000);
        } else {
            var newObj = { beneficiaryId: 0, firstName: '', lastName: '', ssn: '', dateOfBirth: '', hasIep: false, isDeleted: false };
            setBeneficiariesList([...beneficiariesList, newObj]);
        }

    };

    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }

    const handleDeleteBeneficiaryItem = (item, index) => {
    

        const beneficiaryItems = [...beneficiariesList];
        beneficiaryItems.splice(index, 1);
        setBeneficiariesList(beneficiaryItems);


        //if (item.beneficiaryId <= 0) {
            
        //} else {
        //    const updatedArray = beneficiariesList.map((obj, i) => {
        //        if (obj.beneficiaryId === item.beneficiaryId) {
        //            return { ...obj, isDeleted: true };
        //        }
        //        return obj;
        //    });
        //    setBeneficiariesList(updatedArray);
        //}
    };

    const [isBeneficiaryChanged, setIsBeneficiaryChanged] = useState(false);
    const handleBeneInputChange = (e, index) => {
        const { name, value } = e.target;

        const newInputs = [...beneficiariesList];

        if (name == 'hasIep') {
            newInputs[index][name] = e.target.checked;
        } else {
            newInputs[index][name] = value;
        }

        setBeneficiariesList(newInputs);
        setIsBeneficiaryChanged(true);
    };

    //const [selectChildStatus, setSelectChildStatus] = useState(HealthcareTabletProgramApplyFor.Self);

    const handleChildStatus = (event) => {
        //setSelectChildStatus(event.target.value);
        setState(prevState => ({
            ...prevState,
            'applyFor': event.target.value
        }))
    };

    const [fileUrl, setFileUrl] = useState(null);
    const [fieldName, setFieldName] = useState(null);


    const onSave = async (croppedImage, fieldName) => {

        const name = fieldName.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        if (fieldName.name === 'proofOfIdentity') {
            setIdentityImage({
                file: croppedImage,
                fileToSend: croppedImage,
                fileName: fieldName.files[0].name
            })
        } else if (fieldName.name === 'pictureReceiving') {
            setPictureReceivingPhone({
                file: croppedImage,
                fileToSend: croppedImage,
                fileName: fieldName.files[0].name
            })
        }
        setTimeout(() => {
            setCropImageDialog(false)
        })
    };


    const handleFileChange = (e) => {
        openCropImage()
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            const url = URL?.createObjectURL(selectedFile);
            setFileUrl(url);
            setFieldName(e.target)
        }
        
    }




    function uploadSingleFile(e) {
        if (e.target.files == null || e.target.files.length <= 0)
            return
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        if (e.target.name == 'proofOfIdentity') {
            setIdentityImage({
                file: URL.createObjectURL(e.target.files[0]),
                fileToSend: e.target.files[0],
                fileName: e.target.files[0].name
            })
        } else {
            setPictureReceivingPhone({
                file: URL.createObjectURL(e.target.files[0]),
                fileToSend: e.target.files[0],
                fileName: e.target.files[0].name
            })
        }

    }

    const inputFile = useRef(null);

    const uploadFile = () => {

        inputFile.current.click();
    };

    const [selectedOption, setSelectedOption] = useState('SSN');

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };
    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }
    const handleChange = e => {
        const { name, value } = e.target;

        if (value.trim() === "" && value !== "") {
            return;
        }

        const trimmedValue = value.replace("/\s{2,}/g", "");

        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleZipCodeChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
        if (value.trim() != '' && value.trim().length > 4) {
            getStateAndCityOnZipCodeChange(value);
        }

    };
    const removeSpacesFromKeys = (obj) => {
        const newObj = {};
        Object.keys(obj).forEach((key) => {
            const newKey = key.replace(/\s/g, '_');
            newObj[newKey] = obj[key];
        });
        return newObj;
    };
    const getStateAndCityOnZipCodeChange = (zipCode) => {
        axios
            .get(`https://api.zippopotam.us/us/${zipCode}`)
            .then((response) => {
                if (response.data != null && response.data.places != null && response.data.places.length > 0) {

                    const { state, state_abbreviation, place_name } = removeSpacesFromKeys(response.data.places[0]);

                    setState(prevState => ({
                        ...prevState,
                        ['state']: state_abbreviation,
                        ['city']: place_name
                    }))
                }
            })
            .catch((error) => {
                //console.log('Error fetching location data:', error);
            });
    };

    const [isData, setIsData] = useState(false);

    const handlePhoneChange = (e) => {
        const { name, value } = e.target;

        if (e.target.value != "") {
            const re = /^[0-9\b]+$/;
            e.target.value = e.target.value
                .replace(" ", "")
                .replace("(", "")
                .replace(")", "")
                .replace("-", "");
            const { name, value } = e.target;
            if (e.target.value === "" || re.test(e.target.value)) {
                var cleaned = ("" + e.target.value).replace(/\D/g, "");
                var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
                if (match) {
                    var intlCode = match[1] ? "+1 " : "",
                        number = [
                            intlCode,
                            "(",
                            match[2],
                            ") ",
                            match[3],
                            "-",
                            match[4],
                        ].join("");

                    setState((prevState) => ({
                        ...prevState,
                        [name]: number,
                    }));
                    return;
                }
                setState((prevState) => ({
                    ...prevState,
                    [name]: value,
                }));
            } else {
                if (!re.test(e.target.value)) {
                    e.preventDefault();
                }
            }
        } else {
            setState((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const [errorMessages, setErrorMessages] = useState({});
    const [errorChildMessages, setErrorChildMessages] = useState({});

    const genderChange = (e) => {
        const { name, value } = e.target;

        setState(prevState => ({
            ...prevState,
            name: value
        }))
    }

    function toDayDate() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = yyyy + '-' + mm + '-' + dd;
        return today;
    }

    const checkForUniqueBeneficiaries = (validBeneficiaries) => {
        const seen = new Set();

        for (let i = 0; i < validBeneficiaries.length; i++) {
            const beneficiary = validBeneficiaries[i];

            if (!beneficiary.firstName || !beneficiary.lastName || !beneficiary.ssn || !beneficiary.dateOfBirth) {
                continue;
            }

            const uniqueKey = `${beneficiary.firstName.trim()}_${beneficiary.lastName.trim()}_${beneficiary.ssn.trim() }_${beneficiary.dateOfBirth}`;
            if (seen.has(uniqueKey)) {
                return false;
            }
            seen.add(uniqueKey);
        }

        return true;
    };

    const validateChildInformation = (index) => {
        var toDay = toDayDate();
        const validBeneficiaries = beneficiariesList.filter(beneficiary => !beneficiary.isDeleted);
        const child = validBeneficiaries[index];
        const newErrors = {};
        if (!child.firstName) {
            newErrors.firstName = 'Please enter first name';
        }
        if (!child.lastName) {
            newErrors.lastName = 'Please enter last name';
        }
        if (!child.ssn) {
            newErrors.ssn = 'Please enter 4 digits SSN';
        }
        if (!child.dateOfBirth || child.dateOfBirth > toDay) {
            newErrors.dateOfBirth = 'Please enter valid date of birth';
        }
        // if (!child.school) {
        //     newErrors.childSchool = 'Please enter school name';
        // }
        if (Object.keys(newErrors).length > 0) {
            setErrorChildMessages((prevErrors) => ({
                ...prevErrors,
                [index]: newErrors,
            }));
            return true; // Validation failed
        } else {
            setErrorChildMessages((prevErrors) => {
                const newErrors = { ...prevErrors };
                if (newErrors) {
                    delete newErrors[index]
                    return newErrors;
                }
                
            });
        }
    };


    const validateChild = (errorList) => {
        setMatchingChildrenWithParent([]);
        const validBeneficiaries = beneficiariesList.filter(beneficiary => !beneficiary.isDeleted);

        if (!validBeneficiaries || validBeneficiaries.length <= 0) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddChildInfor: true
            }));

            errorList.push(true);

        } else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddChildInfor: false
            }));

        }
        if (validBeneficiaries && validBeneficiaries.length > 0) {
            let errorChildList = [];
            validBeneficiaries.forEach((child, index) => {
                var isChildNotValidated = validateChildInformation(index)
                if (isChildNotValidated) {
                    errorChildList.push(true);
                }
            });

            if (errorChildList.length <= 0) {
                const matchingChildrenIndexes = [];

                if (state.firstName && state.lastName && state.dateOfBirth && state.ssn) {
                    validBeneficiaries.forEach((child, index) => {
                        //check if any child info match to parent info
                        if (
                            child.firstName.trim() === state.firstName.trim() &&
                            child.lastName.trim() === state.lastName.trim() &&
                            child.dateOfBirth === state.dateOfBirth &&
                            child.ssn.trim() === state.ssn.trim()
                        ) {
                            matchingChildrenIndexes.push(index);
                        }
                    });
                    setMatchingChildrenWithParent(matchingChildrenIndexes);
                }

                if (matchingChildrenIndexes.length > 0) {
                    errorList.push(true);
                } else if (!checkForUniqueBeneficiaries(validBeneficiaries)) {
                    errorList.push(true);
                    showMessage("Error", "Please enter unique children information", "error", 3000);
                }

            }
            else {
                errorList.push(true);
            }
        }
    }

    const Validate = (errorList) => {
        if (!state.firstName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: false
            }));
        }

        if (!state.lastName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorLastName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorLastName: false
            }));
        }
        if (selectedOption == 'SSN') {
            if (!state.ssn) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorSSN: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorSSN: false
                }));
            }
        } else {
            if (!state.tin) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorTIN: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorTIN: false
                }));
            }
        }
        var toDay = toDayDate();
        if (!state.dateOfBirth || state.dateOfBirth.trim() === "") {

            setErrorMessages(prevState => ({
                ...prevState,
                errorDOB: true
            }));

            errorList.push(true);

        }
        else if (state.dateOfBirth && state.dateOfBirth > toDay) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDOBFuture: true
            }));

            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDOB: false
            }));
            setErrorMessages(prevState => ({
                ...prevState,
                errorDOBFuture: false
            }));
        }
        //validate children and device information
        if (state.applyFor == HealthcareTabletProgramApplyFor.Beneficiary) {
            validateChild(errorList);

        }

        if (!state.email) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: false
            }));
        }

        if (!state.phone || !validatePhoneNumber(state.phone)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }

        if (!state.address1) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress1: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress1: false
            }));
        }

        //if (!state.address2) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorAddress2: true
        //    }));
        //    errorList.push(true);
        //}

        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorAddress2: false
        //    }));
        //}

        if (!state.city) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: false
            }));
        }

        if (!state.state) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: false
            }));
        }

        if (!state.zipCode) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: true
            }));
            errorList.push(true);
        }

        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: false
            }));
        }

        if (!state.signature) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSignature: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSignature: false
            }));
        }

        if (!state.initials) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInitials: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInitials: false
            }));
        }

        if (!state.documentType) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDocumentType: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDocumentType: false
            }));
        }
        if (!identityImage.file && !state.identityProof) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorIdentityImage: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorIdentityImage: false
            }));
        }




    }

    const trimStringData = () => {
        state.firstName = state?.firstName?.trim();
        state.lastName = state?.lastName?.trim();
        state.email = state?.email?.trim();
        state.address1 = state?.address1?.trim();
        state.city = state?.city?.trim();
        state.signature = state?.signature?.trim();
        state.initials = state?.initials?.trim();
        state.collectedBy = state?.collectedBy?.trim();
    }
    const updateApplication = () => {
        trimStringData();
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {

            state.status = applicationType == 'enrolled' ? "Enrolled" : "Applied";
            if (selectedOption == 'SSN') {
                state.tin = '';
            } else {
                state.ssn = '';
            }
            setIsLoading(true);
            var method = "fdnmcchromicconnect/add";
            if (state.applicationId && state.applicationId > 0) {
                method = "fdnmcchromicconnect/update";
            }
            state.firstName = state.firstName.trim();
            state.lastName = state.lastName.trim();
            state.email = state.email.trim();

            const formData = new FormData();

            for (var key in state) {
                if (state[key] && key != "fileToSend"
                    && key != "fileName"
                    && key != "identityFile"
                    && key != "identityName"
                    && key != "encUserID" && key != 'programBeneficiaries'
                )
                    formData.append(key, state[key]);
            }

            if (state.applyFor == HealthcareTabletProgramApplyFor.Beneficiary) {
                for (var i = 0; i < beneficiariesList.length; i++) {
                    if (beneficiariesList[i].beneficiaryId === 0 && beneficiariesList[i].isDeleted) {
                        continue;
                    }
                    formData.append(`programBeneficiaries[${i}][beneficiaryId]`, beneficiariesList[i].beneficiaryId);
                    formData.append(`programBeneficiaries[${i}][firstName]`, beneficiariesList[i].firstName.trim());
                    formData.append(`programBeneficiaries[${i}][lastName]`, beneficiariesList[i].lastName.trim());
                    formData.append(`programBeneficiaries[${i}][ssn]`, beneficiariesList[i].ssn.trim());
                    formData.append(`programBeneficiaries[${i}][dateOfBirth]`, beneficiariesList[i].dateOfBirth);
                    formData.append(`programBeneficiaries[${i}][hasIep]`, beneficiariesList[i].hasIep);
                    formData.append(`programBeneficiaries[${i}][school]`, beneficiariesList[i].school);
                    formData.append(`programBeneficiaries[${i}][isDeleted]`, beneficiariesList[i].isDeleted);
                    if (beneficiariesList[i].beneficiaryId > 0) {
                        formData.append(`programBeneficiaries[${i}][createDate]`, beneficiariesList[i].createDate);
                    }
                }
            }
            formData.append("identityFile", identityImage.fileToSend ? identityImage.fileToSend : '');
            formData.append("identityName", identityImage.fileName ? identityImage.fileName : state.identityName);
            console.log(state)
            PostDataAPI(method, formData, true, "formData").then((result) => {
                setIsLoading(false);
                if (result.success) {
                    if (result.data) {
                        handleSuccessClose("Application saved successfully");
                    }
                    else {
                        showMessage("Error", "Error saving application, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }
            })
        }

    }


    const isFromTimeIsGreateThanToTime = () => {
        const today = new Date();
        const date1 = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parseInt(state.pickUpFromTime.split(":")[0]), parseInt(state.pickUpFromTime.split(":")[1]));
        const date2 = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parseInt(state.pickUpToTime.split(":")[0]), parseInt(state.pickUpToTime.split(":")[1]));
        return date1 > date2;
    };

    const sendPickUpEmail = () => {
        let errorList = [];
        let errorMessages = [];
        if (!state.pickUpDate) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPickUpDate: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPickUpDate: false
            }));
        }
        if (!state.pickUpFromTime) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFromTime: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFromTime: false
            }));
        }
        if (!state.pickUpToTime) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorToTime: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorToTime: false
            }));
        }
        if (state.pickUpFromTime && state.pickUpToTime && isFromTimeIsGreateThanToTime()) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFromTimeGreater: true
            }));
            errorList.push(true);
        } else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFromTimeGreater: false
            }));
        }

        if (errorList.length < 1) {
            var method = "fdnmcchromicconnect/sendPickupDateTimeEmail";
            setIsLoading(true);
            var params = {
                applicationId: state.applicationId,
                pickUpDate: state.pickUpDate,
                pickUpFromTime: state.pickUpFromTime,
                pickUpToTime: state.pickUpToTime,
                program: state.program
            }
            PostDataAPI(method, params, true).then((result) => {
                setIsLoading(false);
                if (result.success) {
                    if (result.data) {
                        handleSuccessClose("Tablet pickup email sent successfully.");
                    }
                    else {
                        showMessage("Error", "Error sending email, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }
            })
        } else {
        }
    }

    const [unixTimestamp, setUnixTimestamp] = useState(0);
    useEffect(() => {
        setBeneficiariesList([]);
        //var todayDate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1).toString().padStart(2, '0') + '-' + (new Date().getDate() + 1);
        var today = new Date();
        var year = today.getFullYear();
        var month = today.getMonth(); // Month is 0-based
        var day = today.getDate();

        // Get the last day of the current month
        var lastDayOfMonth = new Date(year, month + 1, 0).getDate(); // 0 means the last day of the previous month

        // Check if today is the last day of the month
        if (day === lastDayOfMonth) {
            // Move to the next month
            month += 1;
            day = 1; // Set day to the 1st
            // If the month goes to 12, we need to increment the year
            if (month === 12) {
                month = 0; // Set back to January (0)
                year += 1; // Increment year
            }
        }
        var todayDate = year + '-' + (month + 1).toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0');
        console.log(record)
        // Format the new date
        if (record && record.applicationId > 0) {
            console.log(record)
            var option = (record && record.ssn) ? 'SSN' : 'TribalIdentification'
            setSelectedOption(option);
            record.pickUpDate = !record.pickUpDate || record.pickUpDate == '0001-01-01T00:00:00' ? todayDate : record.pickUpDate.split('T')[0];
            setState(record);
            //var isSelf = (record && record.applyFor) ? record.applyFor : HealthcareTabletProgramApplyFor.Self;
            //setSelectChildStatus(isSelf);

            const updatedBeneficiaries = record.programBeneficiaries
                ? record.programBeneficiaries.map(beneficiary => {
                    if (beneficiary.dateOfBirth && beneficiary.dateOfBirth.includes('T')) {
                        beneficiary.dateOfBirth = beneficiary.dateOfBirth.split('T')[0];
                    }
                    return beneficiary;
                })
                : [];

            setBeneficiariesList(updatedBeneficiaries);
            if (record.updateDate)
                setUnixTimestamp(Math.floor(new Date(record.updateDate).getTime() / 1000));
        }

    }, [record]);

    const [cropImagedialog, setCropImageDialog] = useState(false);

    const openCropImage = () => {
        setCropImageDialog(true)
    }

    const closeCropImage = () => {
        fieldName.value = ""
        setCropImageDialog(false)
    }



    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={DraggableComponent}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>


                {cropImagedialog ?
                    <CropDemo open={openCropImage} onClose={closeCropImage} fieldName={fieldName} src={fileUrl} onSave={onSave}></CropDemo> : ''
                }

                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>{isPreviewMode ? 'Preview' : 'Edit Request - ' + state.firstName + (state.middleName ? ' ' + state.middleName : '') + ' ' + state.lastName + ' | HAPB-' + (state.ssn || state.tin || '')}{state.version && state.version > 0 ? "-" + state.version : ""}</Typography>

                        <Icon className={classes.closeIcon} onClick={()=> closeDialog()} color="primary"><CloseIcon /></Icon>
                    </div>


                    {isLoading ? <DialogLoader></DialogLoader> : ''}
                    <Scrollbars autoHeight autoHeightMax={480}>
                        <div className={classes.content}>

                            <Grid container spacing={2}>
                                <Grid item sm={12} md={12} lg={12} xl={12}>



                                    <Grid container className={classes.collapse}>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <h3 className={classes.sectionHeadingAccord}>Personal Information</h3>
                                            </AccordionSummary>
                                            <AccordionDetails>

                                                <Grid container spacing={3}>

                                                    <Grid item sm={4} md={4} lg={4} xl={4}>
                                                        <Grid row >
                                                            <Label title="First Name" size={12} mandatory={true} />
                                                            <InputBaseField
                                                                name="firstName"
                                                                value={state.firstName}
                                                                onChange={handleChange}
                                                                placeholder="First Name"
                                                                type="text"
                                                                MaxLength={15}
                                                                IsDisabled={isPreviewMode}
                                                            />
                                                            {errorMessages.errorFirstName && !state.firstName ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter first name
                                                            </FormHelperText>) : ('')}
                                                        </Grid>

                                                    </Grid>

                                                    <Grid item sm={4} md={4} lg={4} xl={4}>
                                                        <Grid row >
                                                            <Label title="Middle Name" size={12} />
                                                            <InputBaseField
                                                                name="middleName"
                                                                value={state.middleName}
                                                                onChange={handleChange}
                                                                placeholder="Middle Name"
                                                                type="text"
                                                                MaxLength={15}
                                                                IsDisabled={isPreviewMode}
                                                            />
                                                            {errorMessages.errorMiddleName && !state.middleName ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter middle name
                                                            </FormHelperText>) : ('')}
                                                        </Grid>

                                                    </Grid>


                                                    <Grid item sm={4} md={4} lg={4} xl={4}>
                                                        <Grid row >
                                                            <Label title="Last Name" size={12} mandatory={true} />
                                                            <InputBaseField
                                                                name="lastName"
                                                                value={state.lastName}
                                                                onChange={handleChange}
                                                                placeholder="Last Name"
                                                                type="text"
                                                                MaxLength={15}
                                                                IsDisabled={isPreviewMode}
                                                            />
                                                            {errorMessages.errorLastName && !state.lastName ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter last name
                                                            </FormHelperText>) : ('')}
                                                        </Grid>

                                                    </Grid>

                                                </Grid>



                                                <Grid container>
                                                    <Grid item sm={12} md={12} lg={12} xl={12} className={classes.radioInfo}>
                                                        <FormControl component="fieldset" IsDisabled={isPreviewMode}>
                                                            <RadioGroup name="gender" value={selectedOption} onChange={handleOptionChange}>
                                                                <FormControlLabel value="SSN" control={<Radio />} label="SSN" />
                                                                <FormControlLabel value="TribalIdentification" control={<Radio />} label="Tribal Identification Number" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Grid>

                                                </Grid>

                                                <Grid container spacing={3}>

                                                    {selectedOption == 'SSN' ?
                                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                                            <Grid row>
                                                                <Label title="Last 4 digit SSN" size={12} mandatory={true} />
                                                                <InputBaseField
                                                                    name="ssn"
                                                                    value={state.ssn}
                                                                    onChange={handleChange}
                                                                    placeholder="Last 4 digit SSN"
                                                                    type="text"
                                                                    MaxLength={4}
                                                                    IsDisabled={isPreviewMode}
                                                                    onKeyPress={handleNumberKeyPress}
                                                                />
                                                                {errorMessages.errorSSN && !state.ssn ? (<FormHelperText style={{ color: "red" }} >
                                                                    Please enter last 4 digit SSN
                                                                </FormHelperText>) : ('')}

                                                            </Grid>
                                                        </Grid> :

                                                        <Grid item sm={6} md={6} lg={6} xl={6}>
                                                            <Grid row>
                                                                <Label title="Tribal Identification Number" size={12} mandatory={true} />
                                                                <InputBaseField
                                                                    name="tin"
                                                                    value={state.tin}
                                                                    onChange={handleChange}
                                                                    placeholder="TIN"
                                                                    type="text"
                                                                    MaxLength={14}
                                                                    onKeyPress={handleNumberKeyPress}
                                                                    IsDisabled={isPreviewMode}
                                                                />
                                                                {errorMessages.errorTIN && !state.tin ? (<FormHelperText style={{ color: "red" }} >
                                                                    Please enter tribal identification number
                                                                </FormHelperText>) : ('')}

                                                            </Grid>
                                                        </Grid>

                                                    }

                                                    <Grid item sm={6} md={6} lg={6} xl={6}>

                                                        <Grid row >
                                                            <Label title="Date of Birth" size={12} mandatory={true} />
                                                            <InputBaseField
                                                                name="dateOfBirth"
                                                                value={state.dateOfBirth}
                                                                onChange={handleChange}
                                                                placeholder="Date of Birth"
                                                                type="date"
                                                                IsDisabled={isPreviewMode}
                                                            />
                                                            {errorMessages.errorDOB && !state.dateOfBirth ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter date of birth
                                                            </FormHelperText>) : ('')}
                                                            {errorMessages.errorDOBFuture && state.dateOfBirth > toDayDate() ? (<FormHelperText style={{ color: "red" }} >
                                                                Date of birth cannot be in future
                                                            </FormHelperText>) : ('')}
                                                        </Grid>

                                                    </Grid>


                                                </Grid>
                                                <Grid container className={classes.BeneMain}>
                                                    <Grid item sm={12} md={6} lg={6} xl={6} className={classes.radioInfo}>
                                                        <FormControl component="fieldset">
                                                            <RadioGroup name="gender" value={state.applyFor ? state.applyFor : HealthcareTabletProgramApplyFor.Self} onChange={handleChildStatus}>
                                                                <FormControlLabel value="Self" control={<Radio />} label="Self" />
                                                                <FormControlLabel value={HealthcareTabletProgramApplyFor.Beneficiary} control={<Radio />} label="Children" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                        {errorMessages.errorAddChildInfor && (state.applyFor == HealthcareTabletProgramApplyFor.Beneficiary && (!beneficiariesList || beneficiariesList.length <= 0)) ? (<FormHelperText style={{ color: "red" }} >
                                                            Please add children information
                                                        </FormHelperText>) : ('')}
                                                    </Grid>


                                                </Grid>




                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                    {state.applyFor == HealthcareTabletProgramApplyFor.Beneficiary ?
                                        <Grid container className={classes.collapse}>
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <h3 className={classes.sectionHeadingAccord}>Child Information</h3>
                                                </AccordionSummary>

                                                <AccordionDetails>


                                                    <Grid item sm={12} md={12} lg={12} xl={12}>
                                                        <span className={classes.addNotification} onClick={handleAddBeneficiaryItem}>Add Children <AddCircleOutlineIcon style={{ marginRight: '5px' }} /> </span>
                                                    </Grid>


                                                    {state.applyFor == HealthcareTabletProgramApplyFor.Beneficiary ?
                                                        <>
                                                            <Grid container>
                                                                {beneficiariesList?.filter(t => !t.isDeleted).map((item, index) => (
                                                                    <Grid row container alignItems={'center'}>
                                                                        <Grid xl={12} md={12} sm={12} lg={12} className={classes.paddingLeftRight}>
                                                                            <Grid container className={classes.ChildMain}>
                                                                                <Grid container>
                                                                                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                                                    {beneficiariesList.length == 1 ? '':
                                                                                        <h3 className={classes.childHeading}>Child {index + 1}</h3>
                                                                                    }
                                                                                    </Grid>
                                                                                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className={classes.childClose}>
                                                                                        <span onClick={() => { handleDeleteBeneficiaryItem(item, index) }}>
                                                                                            <img src={DeleteIcon} /></span>
                                                                                    </Grid>
                                                                                </Grid>

                                                                                <Grid container>
                                                                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.paddingFive}>
                                                                                        <Grid row >
                                                                                            <Label title="First Name" size={12} mandatory={true} />
                                                                                            <InputBaseField
                                                                                                name="firstName"
                                                                                                value={item.firstName}
                                                                                                onChange={(event) => { handleBeneInputChange(event, index) }}
                                                                                                placeholder="First Name"
                                                                                                type="text"
                                                                                                MaxLength={50}
                                                                                                useCamelCase={true}
                                                                                            />
                                                                                            {errorChildMessages[index]?.firstName && !item.firstName && (
                                                                                                <span style={{ color: 'red' }}>{errorChildMessages[index]?.firstName}</span>
                                                                                            )}
                                                                                            {/*{errorMessages.errorBeneFirstName && !item.firstName ? (<FormHelperText style={{ color: "red" }} >*/}
                                                                                            {/*    Please enter first name*/}
                                                                                            {/*</FormHelperText>) : ('')}*/}
                                                                                        </Grid>

                                                                                    </Grid>


                                                                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.paddingFive}>
                                                                                        <Grid row >
                                                                                            <Label title="Last Name" size={12} mandatory={true} />
                                                                                            <InputBaseField
                                                                                                name="lastName"
                                                                                                value={item.lastName}
                                                                                                onChange={(event) => { handleBeneInputChange(event, index) }}
                                                                                                placeholder="Last Name"
                                                                                                type="text"
                                                                                                MaxLength={50}
                                                                                                useCamelCase={true}
                                                                                            />
                                                                                            {errorChildMessages[index]?.lastName && !item.lastName && (
                                                                                                <span style={{ color: 'red' }}>{errorChildMessages[index]?.lastName}</span>
                                                                                            )}
                                                                                            {/*{errorMessages.errorBeneLastName && !item.lastName ? (<FormHelperText style={{ color: "red" }} >*/}
                                                                                            {/*    Please enter last name*/}
                                                                                            {/*</FormHelperText>) : ('')}*/}
                                                                                        </Grid>

                                                                                    </Grid>

                                                                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.paddingFive}>
                                                                                        <Grid row >
                                                                                            <Label title="Last 4 digit SSN" size={12} mandatory={true} />
                                                                                            <InputBaseField
                                                                                                name="ssn"
                                                                                                value={item.ssn}
                                                                                                onChange={(event) => { handleBeneInputChange(event, index) }}
                                                                                                placeholder="Last 4 digit SSN"
                                                                                                type="text"
                                                                                                MaxLength={4}
                                                                                                onKeyPress={handleNumberKeyPress}
                                                                                            />
                                                                                            {errorChildMessages[index]?.ssn && !item.ssn && (
                                                                                                <span style={{ color: 'red' }}>{errorChildMessages[index]?.ssn}</span>
                                                                                            )}
                                                                                            {/*{errorMessages.errorBeneSSN && !item.ssn ? (<FormHelperText style={{ color: "red" }} >*/}
                                                                                            {/*    Please enter last 4 digit SSN*/}
                                                                                            {/*</FormHelperText>) : ('')}*/}
                                                                                        </Grid>

                                                                                    </Grid>


                                                                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.paddingFive}>
                                                                                        <Grid row >
                                                                                            <Label title="Date of Birth" size={12} mandatory={true} />
                                                                                            <InputBaseField
                                                                                                name="dateOfBirth"
                                                                                                value={item.dateOfBirth}
                                                                                                onChange={(event) => { handleBeneInputChange(event, index) }}
                                                                                                placeholder="Date of Birth"
                                                                                                type="date"
                                                                                                MaxLength={14}
                                                                                            />
                                                                                            {errorChildMessages[index]?.dateOfBirth && (!item.dateOfBirth || (item.dateOfBirth && item.dateOfBirth > toDayDate())) && (
                                                                                                <span style={{ color: 'red' }}>{errorChildMessages[index]?.dateOfBirth}</span>
                                                                                            )}
                                                                                            {/*{errorMessages.errorBeneDOB && (!item.dateOfBirth || (item.dateOfBirth && item.dateOfBirth > toDayDate())) ? (<FormHelperText style={{ color: "red" }} >*/}
                                                                                            {/*    Please enter valid date of birth*/}
                                                                                            {/*</FormHelperText>) : ('')}*/}
                                                                                        </Grid>

                                                                                    </Grid>
                                                                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.paddingFive}>
                                                                                        <Grid row >
                                                                                            <Label title="School Name" size={12} />
                                                                                            <InputBaseField
                                                                                                name="school"
                                                                                                value={item.school == 'null' || item.school== null || item.school== 'undefined'? null: item.school}
                                                                                                onChange={(event) => { handleBeneInputChange(event, index) }}
                                                                                                placeholder="School Name"
                                                                                                type="text"
                                                                                                MaxLength={50}
                                                                                                useCamelCase={true}
                                                                                            />
                                                                                            
                                                                                        </Grid>

                                                                                    </Grid>

                                                                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.checkboxMain}>
                                                                                        <FormControlLabel
                                                                                            className={classes.checkBox}
                                                                                            control={<Checkbox onChange={(event) => { handleBeneInputChange(event, index) }} name="hasIep" checked={item.hasIep} />}
                                                                                            label="Does this child have an individual learning plan (IEP) ?"
                                                                                        />
                                                                                    </Grid>
                                                                                    {matchingChildrenWithParent.includes(index) && (
                                                                                        <p style={{ color: "red" }}>
                                                                                            This child's information matches the parent's information.
                                                                                        </p>
                                                                                    )}

                                                                            </Grid>
                                                                        </Grid>

                                                                        </Grid>




                                                                    </Grid>
                                                                ))
                                                                }
                                                            </Grid></>
                                                        : ''}

                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                        : ''
                                    }


                                    <Grid container className={classes.collapse}>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <h3 className={classes.sectionHeadingAccord}>Contact Information</h3>
                                            </AccordionSummary>
                                            <AccordionDetails>

                                                <Grid container spacing={2} >
                                                    <Grid item sm={6} md={6} lg={6} xl={6}>
                                                        <Grid row >
                                                            <Label title="Email Address" size={12} mandatory={true} />

                                                            <InputBaseField
                                                                name="email"
                                                                value={state.email}
                                                                onChange={handleChange}
                                                                placeholder="Email Address"
                                                                type="text"
                                                                MaxLength={50}
                                                                IsDisabled={isPreviewMode}
                                                            />
                                                            {errorMessages.errorEmailAddress && (!state.email || !validateEmail(state.email)) ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter valid email
                                                            </FormHelperText>) : ('')}
                                                        </Grid>
                                                    </Grid>


                                                    <Grid item sm={6} md={6} lg={6} xl={6}>
                                                        <Grid row >
                                                            <Label title="Phone #" size={12} mandatory={true} />
                                                            <InputBaseField
                                                                name="phone"
                                                                value={state.phone}
                                                                onChange={handlePhoneChange}
                                                                placeholder="Phone #"
                                                                type="text"
                                                                MaxLength={14}
                                                                IsDisabled={isPreviewMode}
                                                            />
                                                            {errorMessages.errorPhone && (!state.phone || !validatePhoneNumber(state.phone)) ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter valid phone number
                                                            </FormHelperText>) : ('')}
                                                        </Grid>

                                                    </Grid>

                                                </Grid>



                                                <Grid container spacing={2}>
                                                    <Grid item sm={6} md={6} lg={6} xl={6}>
                                                        <Grid row >
                                                            <Label title="Address" size={12} mandatory={true} />
                                                            <InputBaseField
                                                                name="address1"
                                                                value={state.address1}
                                                                onChange={handleChange}
                                                                placeholder="Address"
                                                                type="text"
                                                                MaxLength={50}
                                                                IsDisabled={isPreviewMode}
                                                            />
                                                            {errorMessages.errorAddress1 && !state.address1 ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter address
                                                            </FormHelperText>) : ('')}
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item sm={6} md={6} lg={6} xl={6}>
                                                        <Grid row >
                                                            <Label title="Apartment, Unit, etc." size={12} />
                                                            <InputBaseField
                                                                name="address2"
                                                                value={state.address2}
                                                                onChange={handleChange}
                                                                placeholder="Apartment, Unit, etc."
                                                                type="text"
                                                                MaxLength={50}
                                                                IsDisabled={isPreviewMode}
                                                            />
                                                            {errorMessages.errorAddress2 && !state.address2 ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter apartment unit
                                                            </FormHelperText>) : ('')}
                                                        </Grid>

                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={2}>
                                                    <Grid item sm={4} md={4} lg={4} xl={4}>
                                                        <Grid row >
                                                            <Label title="Zip Code" size={12} mandatory={true} />
                                                            <InputBaseField
                                                                name="zipCode"
                                                                value={state.zipCode}
                                                                onChange={handleZipCodeChange}
                                                                placeholder="Zip Code"
                                                                type="text"
                                                                MaxLength={9}
                                                                IsDisabled={isPreviewMode}
                                                                onKeyPress={handleNumberKeyPress}
                                                            />
                                                            {errorMessages.errorZip && !state.zipCode ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter zip code
                                                            </FormHelperText>) : ('')}
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item sm={4} md={4} lg={4} xl={4}>
                                                        <Grid row >
                                                            <Label title="City" size={12} mandatory={true} />
                                                            <InputBaseField
                                                                name="city"
                                                                value={state.city}
                                                                onChange={handleChange}
                                                                placeholder="City"
                                                                type="text"
                                                                MaxLength={14}
                                                                IsDisabled={isPreviewMode}
                                                            />
                                                            {errorMessages.errorCity && !state.city ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter city
                                                            </FormHelperText>) : ('')}
                                                        </Grid>

                                                    </Grid>

                                                    <Grid item sm={4} md={4} lg={4} xl={4}>
                                                        <Grid row >
                                                            <Label title="State" size={12} mandatory={true} />
                                                            <Select
                                                                size="small"
                                                                native
                                                                name="state"
                                                                value={state?.state}
                                                                onChange={handleSelectChange}
                                                                disabled={isPreviewMode}
                                                                placeholder="Select"
                                                                label="Select"
                                                                className={classes.selectBaseInput}
                                                            >
                                                                {lstStates.map(option =>
                                                                    <option value={option.value}>{option.label}</option>
                                                                )
                                                                }
                                                            </Select>
                                                            {errorMessages.errorState && !state.state ? (<FormHelperText style={{ color: "red" }} >
                                                                Please select state
                                                            </FormHelperText>) : ('')}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                    <Grid container className={classes.collapse}>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <h3 className={classes.sectionHeadingAccord}>Consent and Agreement</h3>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container spacing={2}>

                                                    <Grid item sm={6} md={6} lg={6} xl={6}>
                                                        <Grid row>
                                                            <Label title="Signature" size={12} mandatory={true} />
                                                            <InputBaseField
                                                                name="signature"
                                                                value={state.signature}
                                                                onChange={handleChange}
                                                                placeholder="Signature"
                                                                IsDisabled={isPreviewMode}
                                                                type="text"
                                                                MaxLength={10}
                                                            />
                                                            {errorMessages.errorSignature && !state.signature ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter signature
                                                            </FormHelperText>) : ('')}
                                                        </Grid>

                                                    </Grid>


                                                    <Grid item sm={6} md={6} lg={6} xl={6}>
                                                        <Grid row>
                                                            <Label title="Your Initials" size={12} mandatory={true} />
                                                            <InputBaseField
                                                                name="initials"
                                                                value={state.initials}
                                                                onChange={handleChange}
                                                                placeholder="Your Initials"
                                                                IsDisabled={isPreviewMode}
                                                                type="text"
                                                                MaxLength={7}
                                                            />
                                                            {errorMessages.errorInitials && !state.initials ? (<FormHelperText style={{ color: "red" }} >
                                                                Please enter initials
                                                            </FormHelperText>) : ('')}
                                                        </Grid>

                                                    </Grid>


                                                </Grid>

                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>




                                    <Grid container className={classes.collapse}>
                                        <Accordion defaultExpanded={isSendPickUpEmail ? false : true}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <h3 className={classes.sectionHeadingAccord}> Proof of Identity</h3>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                {isData ?
                                                    <>

                                                        <Grid container spacing={2} className={identityImage.file || state.identityProof ? classes.imageBox : ''}>
                                                            <Grid item sm={12} md={12} lg={12} xl={12}>
                                                                {identityImage.file || state.identityProof ?
                                                                    <>
                                                                        <img src={identityImage.file ? identityImage.file : '.' + state.identityProof + '?v=' + unixTimestamp} width="100%" />
                                                                    </>
                                                                    : <img src={PreviewPhoto} width="100%" />
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                    :
                                                    <>
                                                        <Grid container spacing={2}>
                                                            <Grid item sm={6} md={6} lg={6} xl={6}>
                                                                <Grid row>
                                                                    <Label title="Document Type" size={12} mandatory={true} />

                                                                    <Select
                                                                        size="small"
                                                                        native
                                                                        name="documentType"
                                                                        value={state?.documentType}
                                                                        onChange={handleSelectChange}
                                                                        placeholder="Select"
                                                                        label="Select"
                                                                        disabled={isPreviewMode}
                                                                        className={classes.selectBaseInput}
                                                                    >
                                                                        {documentType.map(option =>
                                                                            <option value={option.value}>{option.label}</option>
                                                                        )
                                                                        }
                                                                    </Select>
                                                                    {errorMessages.errorDocumentType && !state.documentType ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please select document type
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>
                                                            </Grid>
                                                            {!isPreviewMode ? <Grid item sm={6} md={6} lg={6} xl={6}>
                                                                <Grid row>
                                                                    <Label title="Upload Document" size={12} mandatory={true} />
                                                                    <input type="file" id="fileUploadField" name="proofOfIdentity"ref={inputFile} className={classes.inputFile} onChange={handleFileChange} accept=".png, .jpg, .jpeg" />
                                                               
                                                                    <label htmlFor="fileUploadField" className={classes.customFileButton}>
                                                                        <span className={classes.spanBtn}>Choose file</span> {identityImage.file ? identityImage.fileName : state.identityName ? state.identityName :'Choose a file'} 
                                                                    </label>
                                                                    
                                                                    <div className={classes.fileExtenNotif}><i>.png, .jpg, .jpeg files only</i></div>
                                                                    {errorMessages.errorIdentityImage && !identityImage.file ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please select document
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>

                                                            </Grid> : <Grid item sm={6} md={6} lg={6} xl={6} container className={identityImage.file || state.identityProof ? classes.imageBox : ''} style={{ maxWidth: '60%', margin: '10px auto' }}>
                                                                {identityImage.file || state.identityProof ?
                                                                    <>
                                                                        <img src={identityImage.file ? identityImage.file : '.' + state.identityProof + '?v=' + unixTimestamp} className={classes.previewImg} id="previewimg" style={{ borderRadius: '10px', borderColor: 'gray', borderWidth: '2px', margin: '5px', width: '325px', height: '204.1px' }} />
                                                                    </>
                                                                    : ''
                                                                }
                                                            </Grid>}



                                                        </Grid>
                                                        {!isPreviewMode ?
                                                            <Grid container className={identityImage.file || state.identityProof ? classes.imageBox : ''} style={{ maxWidth: '60%', margin: '10px auto' }}>
                                                            {identityImage.file || state.identityProof ?
                                                                <>
                                                                    <img src={identityImage.file ? identityImage.file : '.' + state.identityProof + '?v=' + unixTimestamp} className={classes.previewImg} id="previewimg" style={{ borderRadius: '10px', borderColor: 'gray', borderWidth: '2px', margin: '5px', width: '325px', height: '204.1px' }} />
                                                                </>
                                                                : ''
                                                            }
                                                        </Grid> : ''}
                                                    </>

                                                }
                                            </AccordionDetails>
                                        </Accordion>

                                    </Grid>

                                    <Grid container className={classes.collapse}>
                                        <Accordion defaultExpanded={isSendPickUpEmail ? true : false}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <h3 className={classes.sectionHeadingAccord}> Pickup Date Time</h3>
                                            </AccordionSummary>
                                            <AccordionDetails>


                                                <Grid row spacing={2}>
                                                    <Grid container>

                                                        <Grid container alignItems="center">

                                                            <Grid item sm={3} md={3} lg={3} xl={3} style={{ padding: '5px' }}>

                                                                <Label title="Date" size={12} mandatory={true} />
                                                                <InputBaseField
                                                                    id="pickUpDate"
                                                                    name="pickUpDate"
                                                                    value={state.pickUpDate}
                                                                    onChange={handleChange}
                                                                    placeholder="Pickup Date"
                                                                    type="date"
                                                                    minDateTime={new Date().toISOString().split('T')[0]}
                                                                />
                                                            </Grid>

                                                            <Grid item sm={3} md={3} lg={3} xl={3} style={{ padding: '5px' }}>
                                                                <Grid row >
                                                                    <Label title="From Time" size={12} mandatory={true} />
                                                                    <InputBaseField
                                                                        name="pickUpFromTime"
                                                                        value={state.pickUpFromTime}
                                                                        onChange={handleChange}
                                                                        placeholder="Time"
                                                                        type="time"
                                                                        MaxLength={14}
                                                                    />
                                                                    {errorMessages.errorFromTime && !state.pickUpFromTime ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please select pick up from time
                                                                    </FormHelperText>) : ('')}
                                                                    {errorMessages.errorFromTimeGreater && state.pickUpFromTime && state.pickUpToTime && isFromTimeIsGreateThanToTime() ? (<FormHelperText style={{ color: "red" }} >
                                                                        From time should not be greater than to time
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>

                                                            </Grid>

                                                            <Grid item sm={3} md={3} lg={3} xl={3} style={{ padding: '5px' }}>
                                                                <Grid row >
                                                                    <Label title="To Time" size={12} mandatory={true} />
                                                                    <InputBaseField
                                                                        name="pickUpToTime"
                                                                        value={state.pickUpToTime}
                                                                        onChange={handleChange}
                                                                        placeholder="Time"
                                                                        type="time"
                                                                        MaxLength={14}
                                                                    />
                                                                    {errorMessages.errorToTime && !state.pickUpToTime ? (<FormHelperText style={{ color: "red" }} >
                                                                        Please select pick up to time
                                                                    </FormHelperText>) : ('')}
                                                                </Grid>

                                                            </Grid>
                                                            <Grid item sm={3} md={3} lg={3} xl={3}>
                                                                <Grid row >
                                                                    <Button className={classes.changeBtn} style={{ marginTop: '21px', marginLeft: '4px' }} onClick={() => { sendPickUpEmail() }}>Send Email</Button>
                                                                </Grid>
                                                            </Grid>

                                                        </Grid>

                                                    </Grid>
                                                </Grid>



                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>


                                </Grid>


                            </Grid>
                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={()=> closeDialog()}>Close</Button>
                            {!isPreviewMode ? <Button className={classes.changeBtn} onClick={updateApplication}>Submit</Button> : ''}

                        </div>
                    </div>
                </div>
            </div>
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

        </Dialog >

    )
}

export default withSnackbar(EditRequest);
